module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slowest.fdc5a566.svg";